import { apiRequest } from "../api";

export const loginAdmin = (credentials: unknown) =>
  apiRequest("/login", "POST", credentials);
export const logoutAdmin = () => apiRequest("/logout", "GET");
